import { render, staticRenderFns } from "./CreateOrEditOld.vue?vue&type=template&id=0a285baa&scoped=true"
import script from "./CreateOrEditOld.vue?vue&type=script&lang=js"
export * from "./CreateOrEditOld.vue?vue&type=script&lang=js"
import style0 from "./CreateOrEditOld.vue?vue&type=style&index=0&id=0a285baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a285baa",
  null
  
)

export default component.exports